module.exports = __webpack_public_path__ + "img/mediana-logo-small-white.fc39d373.svg";